import { api } from '../../config';

class PlayerService {
  async getPlayer(playerTag) {
    return await api.get('/player/' + playerTag);
  }
}

export default new PlayerService();
